export const EVENT_CODES = {
  PAGE_VIEW: 'PMC_PAGE_VIEW',
  SIGN_UP: 'PMC_SIGN_UP',
  SIGN_IN: 'PMC_SIGN_IN',
  ERROR: 'PMC_ERROR',
  PURCHASE: 'PMC_PURCHASE',
  CONVERSION: 'PMC_CONVERSION',
  CTA_CLICK: 'PMC_CTA_CLICK',
  PLAN_CREATED: 'PMC_PLAN_CREATED',
  CREATE_PLAN_FUNNEL: 'PMC_CREATE_PLAN_FUNNEL',
  CREATE_PLAN_ERROR: 'PMC_CREATE_PLAN_ERROR',
  ASSESSMENT_START: 'PMC_ASSESSMENT_START',
  ASSESSMENT_COMPLETE: 'PMC_ASSESSMENT_COMPLETE',
  ASSESSMENT_REPORT_VIEWED: 'PMC_ASSESSMENT_REPORT_VIEWED',
  ASSESSMENT_PDF_DOWNLOADED: 'PMC_ASSESSMENT_PDF_DOWNLOADED',
  ASSESSMENT_SHARE_CREATED: 'PMC_ASSESSMENT_SHARE_CREATED',
  ASSESSMENT_PLAN_CTA_CLICKED: 'PMC_ASSESSMENT_PLAN_CTA_CLICKED',
  PLATFORM_SWITCH: 'PMC_PLATFORM_SWITCH',
  STUDIO_LAUNCH_STARTED: 'PMC_STUDIO_LAUNCH_STARTED',
  STUDIO_LAUNCH_COMPLETED: 'PMC_STUDIO_LAUNCH_COMPLETED',
  STUDIO_LAUNCH_FAILED: 'PMC_STUDIO_LAUNCH_FAILED',
  CERTIFICATE_NUDGE_TOAST_SHOWN: 'PMC_CERTIFICATE_NUDGE_TOAST_SHOWN',
  CERTIFICATE_NUDGE_TOAST_DISMISSED: 'PMC_CERTIFICATE_NUDGE_TOAST_DISMISSED',
  CERTIFICATE_NUDGE_TOAST_CTA_CLICK: 'PMC_CERTIFICATE_NUDGE_TOAST_CTA_CLICK',
  CERTIFICATE_NUDGE_BELL_OPEN: 'PMC_CERTIFICATE_NUDGE_BELL_OPEN',
  CERTIFICATE_NUDGE_BELL_CTA_CLICK: 'PMC_CERTIFICATE_NUDGE_BELL_CTA_CLICK',
} as const;

export type AnalyticsEventCode = (typeof EVENT_CODES)[keyof typeof EVENT_CODES];
